import React from 'react';
import PropTypes from 'prop-types';
import { TableCell } from 'smartsuite-ui';
import useLink from '../../../../shared/hooks/linkHooks';

export default function AdvancedSearchLink({
    columnConfig,
    metricRequest,
    openLinksInNewTab,
    resultRow,
    value,
}) {
    const linkUri = useLink(columnConfig, metricRequest, resultRow);

    return (
        <TableCell
            cssClassModifiers={[columnConfig.isLeftAligned ? 'left-align' : '']}
        >
            <a
                href={linkUri}
                target={openLinksInNewTab ? '_blank' : ''}
                rel="noreferrer"
            >
                {value}
            </a>
        </TableCell>
    );
}

AdvancedSearchLink.propTypes = {
    columnConfig: PropTypes.instanceOf(Object).isRequired,
    resultRow: PropTypes.instanceOf(Object),
    metricRequest: PropTypes.instanceOf(Object).isRequired,
    openLinksInNewTab: PropTypes.bool.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
